import React, {forwardRef} from 'react'
import tw from 'tailwind-styled-components'
import {Hub} from 'yougile-model'
import {Icon} from '@components/common/base/icon'
import {getStickerTypeMessage} from '@components/sticker/my-stickers/utils'
import {Sticker} from '@extensions/sticker/sticker'
import {StickerLibrary} from '../../../my-stickers-utils'
import {ListItemProjectsAndBoards} from './list-item-projects-and-boards'
import {ListItemStickerName} from './list-item-sticker-name'
import {ListItemToggleSticker} from './list-item-toggle-sticker'
import {ListItemUser} from './list-item-user'

const TwListItem = tw.div`
  cursor-pointer
  group
  p-8
  hover:bg-background-hover
`

const TwUserComponent = tw.div`
  flex
  gap-24
  items-baseline
  rounded-4
`

const TwType = tw.div`
  pl-24
  text-xs-regular
  text-secondary
`

interface Props {
  stickerLibrary: StickerLibrary
  highlight?: boolean
  board: Hub
}

export const ListItem = forwardRef<HTMLDivElement, Props>(
  ({stickerLibrary, highlight, board}, forwardedRef) => {
    const sticker = stickerLibrary.sticker
    const icon = Sticker.getIcon(sticker) || 'string'

    return (
      <TwListItem ref={forwardedRef}>
        <TwUserComponent>
          <div className="flex flex-col flex-1 min-w-0 gap-2 max-w-[160px]">
            <div className="flex items-center">
              <Icon className="mr-8" icon={icon} />
              <ListItemStickerName
                stickerLibrary={stickerLibrary}
                highlight={highlight}
              />
            </div>
            <TwType>{getStickerTypeMessage(sticker)}</TwType>
            <ListItemUser sticker={sticker} />
          </div>
          <ListItemProjectsAndBoards
            stickerLibrary={stickerLibrary}
            highlight={highlight}
          />
          <ListItemToggleSticker
            stickerLibrary={stickerLibrary}
            board={board}
          />
        </TwUserComponent>
      </TwListItem>
    )
  }
)
